// **直播广场接口列表**

import base from '../base.js'; // 导入接口域名列表
import axios from '../http.js'; // 导入http中创建的axios实例

const bus = {
    // 获取创作者授权二维码
    grant(params) {
        return axios.get(`${base.bds}/oauth/creator_qr_code/`, {
            params: params
        });
    },
    // 获取百应授权二维码
    grantB(params) {
        return axios.get(`${base.bds}/oauth/buyin_qr_code/`, {
            params: params
        });
    },
    // 获取抖店授权二维码
    grantC(params) {
        return axios.get(`${base.bds}/oauth/doudian_qr_code`, {
            params: params
        });
    },
    // 获取创作者授权二维码结果
    grantResult(params) {
        return axios.post(`${base.bds}/oauth/creator_qr_code/`, params);
    },
    // 获取百应授权二维码结果
    grantBResult(params) {
        return axios.post(`${base.bds}/oauth/buyin_qr_code/`, params);
    },
    // 获取抖店授权二维码结果
    grantCResult(params) {
        return axios.post(`${base.bds}/oauth/doudian_qr_code/`, params);
    },
    // 主播信息
    authorInfo(params) {
        return axios.get(`${base.bds}/dy/authorinfo/`, {
            params: params
        });
    },
    // 历史直播
    getHistory (params) {
        return axios.get(`${base.bds}/oauth/creator_room_list/`, {
            params: params
        });
    },
    // 商家历史直播
    getMerchantHistory (params) {
        return axios.get(`${base.bds}/oauth/auth_room_cooperation_author_room_list_by_merchant`, {
            params: params
        });
    },
    // 房间信息
    roomInfo (params) {
        return axios.get(`${base.bds}/oauth/auth_room_detail/`, {
            params: params
        });
    },
    // 商家房间信息
    roomInfoMerchant (params) {
        return axios.get(`${base.bds}/oauth/auth_room_detail_by_merchant/`, {
            params: params
        });
    },
    // 获取流量时序数据
    sequential (params) {
        return axios.get(`${base.bds}/oauth/auth_room_all_tendency/`, {
            params: params
        });
    },
    // 获取商家流量时序数据
    sequentialMerchant (params) {
        return axios.get(`${base.bds}/oauth/auth_room_all_tendency_by_merchant/`, {
            params: params
        });
    },
    // 获取福袋数据
    blessingBag (params) {
        return axios.get(`${base.bds}/oauth/auth_room_lucky_bag/`, {
            params: params
        });
    },
     // 获取上架数据
     putOnTheShelf (params) {
        return axios.get(`${base.bds}/oauth/auth_room_get_add_product/`, {
            params: params
        });
    },
    // 获取授权二维码结果
    grantBResult(params) {
        return axios.post(`${base.bds}/oauth/buyin_qr_code/`, params);
    },
    // 主播最近场次图
    getSessions(params) {
        return axios.get(`${base.bds}/oauth/recent_room_watch_pv/`, {
            params: params
        });
    },
    // 获取流量结构时序数据
    structure (params) {
        return axios.get(`${base.bds}/oauth/auth_room_all_source_tendency/`, {
            params: params
        });
    },
    // 获取合作列表
    getList (params) {
        return axios.get(`${base.bds}/oauth/merchant_author_list/`, {
            params: params
        });
    },
    // 获取奖品列表
    getExplainList (params) {
        return axios.get(`${base.bds}/oauth/auth_room_products_explain_detail/`, {
            params: params
        });
    }
}

export default bus;



// WEBPACK FOOTER //
// ./src/utils/api/grant.js